/**
 * pp-product-form-modal — abre el modal con el form embebido cuando
 * el usuario hace click en un botón con [data-pp-form-trigger="X"]
 * (X = "informativo" o "sobre_pedido"). Reemplaza el viejo flujo de
 * Zoho Forms.
 *
 * Flujo:
 *   1. El botón en pp-main-product.liquid lleva el SKU + title como
 *      data attributes.
 *   2. Al click: localiza el <dialog data-pp-form-modal="X">, setea
 *      el src del iframe a la URL del form con query string
 *      (?sku=...&producto=...&parent_url=...) y abre el dialog.
 *   3. El iframe emite postMessage { type: "pp-form-height", height }
 *      cada vez que su contenido cambia de tamaño; aquí ajustamos la
 *      altura del iframe para evitar scroll interno.
 *   4. Al cerrar el dialog, limpiamos el src del iframe para detener
 *      cualquier trabajo en background (igual que el modal de video).
 */

(function () {
  'use strict';

  function buildIframeUrl(baseUrl, trigger) {
    const url = new URL(baseUrl);
    const sku = trigger.dataset.ppProductSku || '';
    const producto = trigger.dataset.ppProductTitle || '';
    if (sku) url.searchParams.set('sku', sku);
    if (producto) url.searchParams.set('producto', producto);
    url.searchParams.set('parent_url', window.location.href);
    return url.toString();
  }

  function openModal(modal) {
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  function init() {
    const triggers = document.querySelectorAll('[data-pp-form-trigger]');
    if (!triggers.length) return;

    triggers.forEach((trigger) => {
      const tipo = trigger.dataset.ppFormTrigger;
      const modalName = tipo === 'sobre_pedido' ? 'form-sobre-pedido' : 'form-informativo';
      const modal = document.querySelector(`[data-pp-modal="${modalName}"]`);
      if (!modal) return;

      const iframe = modal.querySelector('[data-pp-form-iframe]');
      const baseUrl = modal.dataset.ppFormBaseUrl;
      if (!iframe || !baseUrl) return;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        iframe.src = buildIframeUrl(baseUrl, trigger);
        openModal(modal);
      });
    });

    document.querySelectorAll('[data-pp-form-modal]').forEach((modal) => {
      const iframe = modal.querySelector('[data-pp-form-iframe]');
      if (!iframe) return;

      const closeBtn = modal.querySelector('[data-pp-modal-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => modal.close());

      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.close();
      });

      modal.addEventListener('close', () => {
        iframe.src = 'about:blank';
      });
    });

    window.addEventListener('message', (event) => {
      if (!event.data || event.data.type !== 'pp-form-height') return;
      const height = Number(event.data.height);
      if (!Number.isFinite(height) || height < 100) return;
      document.querySelectorAll('[data-pp-form-iframe]').forEach((iframe) => {
        iframe.style.height = `${Math.min(height + 24, 900)}px`;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
